<template>
    <div class="alert position-sticky top-0 end-0" :class="alertType()" role="alert">
        {{ title }}
    </div>
</template>

<script>
export default {
    name: 'ToasterComponent',
    props: {
        title: String,
        type: String,
    },
    methods: {
        alertType() {
            if(this == null)
                return null;

            switch(this.type){
                case 'error': {
                    return 'alert-danger';
                }
                case 'warn': {
                    return 'alert-warning';
                }
                case 'success': {
                    return 'alert-success';
                }
            }
        },
    },
}
</script>

<style lang="scss" scoped>

</style>